import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  dialogPaper: {
    minWidth: "400px",
  },
  buttons: {
    justifyContent: "space-between",
  },
  inputRoot: {
    "& .Mui-disabled": {
      color: "#000000de"
    },
  },
}))

export default styles
